import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';
import { toIconName } from '@/shared/utils/toIconName';
import type { ICategory } from '@/entities/category/model/types/categories';
import type { IRegionCity } from '@/entities/location/model/types/location';
import type { Item } from '@/shared/ui/ColumnsBlock/model/types/columnsBlock';

export const FIND_LAWYER_CITIES_LIMIT = 59;

export const buildFindLawyerCategoryItems = (categories: ICategory[]): Item[] =>
  categories.map((category) => ({
    id: category.id,
    name: category.name,
    link: `${ROOT_CATALOG_URL}${category.slug}/`,
    iconName: toIconName(category.slug),
  }));

export const buildFindLawyerCityItems = (cities: IRegionCity[]): Item[] =>
  cities.map((city) => ({
    id: city.id,
    name: city.name,
    link: `${ROOT_CATALOG_URL}geo/${city.slug}/`,
  }));

export const filterItemsByName = (items: Item[], query: string): Item[] => {
  const text = query.trim().toLowerCase();
  if (!text) return items;
  return items.filter((item) => item.name.toLowerCase().includes(text));
};
